// Portal Sass Colors
//
//   iceBlue: "#eaf3f8",
//   veryLightBlue: "#e1f1f6",
//   lightBlue: "#89cbdf",
//   seconaryActive: "#00aafc",
//   activeMenuIcon: "#0092e0",
//   secondaryBlue: "#0084ba",
//   hoverBlue: "#1f82b5",
//   cerulean: "#007cbb",
//   oceanBlue: "#006da8",
//   twilightBlue: "#074f86",
//   navy: "#00223c",
//   veryLightGreen: "#dff0d0",
//   kermitGreen: "#65b500",
//   jungleGreen: "#04844b",
//   orange: "#ff7e1c",
//   pale: "#f5dbd9",
//   paleTwo: "#ffeadb",
//   paleSalmon: "#ebafa6",
//   burntOrange: "#c25400",
//   rustRed: "#c92100",
//   statusBorder: "#2e294e",
//   white: "#ffffff",
//   veryLightPink: "#efefef",
//   statusGlobal: "#eae9ed",
//   statusPublished: "#e9e8f4",
//   lighterGrey: "#dddbda",
//   lightGrey: "#dadada",
//   midLightGray: "#d5d5d5",
//   lightPeach: "#d1cece",
//   pinkishGrey: "#c6c4c4",
//   brownGrey: "#8a8a8a",
//   lightGreyishBrown: "#7f7f7f",
//   greyishBrown: "#4f4f4f",
//   black: "#000000",

export const blue = {
  100: '#eaf3f8', // hover
  200: '#89cbdf',
  300: '#00aafc',
  400: '#0092e0',
  500: '#0084ba', // secondary button
  600: '#006da8', // ocean blue
  700: '#074F86', // primary
  800: '#00223C'
};

export const neutral = {
  100: '#ffffff',
  200: '#efefef',
  250: '#dadada',
  300: '#d1cece',
  400: '#c6c4c4',
  500: '#8a8a8a',
  550: '#7f7f7f',
  600: '#4f4f4f',
  700: '#000000'
};

export const status = {
  success: {
    light: '#dff0d0', // p2 fill
    medium: '#65B500', // p2 border
    dark: '#04844B' // p1 fill
  },
  error: {
    light: '#f5dbd9',
    medium: '#ebafa6',
    dark: '#c92100'
  },
  warning: {
    light: '#ffeadb',
    medium: '#ff7e1c',
    dark: '#C25400'
  },
  info: {
    light: '#e1f1f6',
    medium: '#89cbdf',
    dark: '#007cbb'
  },
  deactive: '#8a8a8a'
};

export const pallette = {
  primary: blue[700],
  backgroundLight: neutral[100],
  backgroundDark: blue[800],
  textLight: neutral[100],
  textDark: neutral[700],
  ...status
};
